export default __webpack_public_path__ + "static/media/francheville33.0826e422.jpg";